/** Deal Profiles Investment Opportunity uses investor profile PreferredInvestmentTypeEnum as they are equivalent */

enum DealProfileBuyerLocationEnum {
  LocalInvestor = 'Local (state)',
  RegionalInvestor = 'Regional',
  NationalOrInternationalInvestor = 'National',
}

export default DealProfileBuyerLocationEnum;
